import { Component, Input } from '@angular/core';
import { Terminal } from '../../../@core/domain/interfaces/terminal.interface';

@Component({
  selector: 'app-terminal-title',
  templateUrl: './terminal-title.component.html',
  styleUrls: ['./terminal-title.component.scss'],
})
export class TerminalTitleComponent {
  @Input()
  terminal!: Terminal;

  @Input()
  show = true;

  @Input()
  showHeading = true;

  constructor() {}

  terminalStatusColor() {
    switch (this.terminal.status.id) {
      case 0:
        return 'status-red';
      case 1:
        return 'status-green';
      case 2:
      case 3:
      case 4:
        return 'status-red';
      case 5:
      case 6:
      case 7:
      case 8:
        return 'status-green';
      case 9:
        return 'status-red';
      case 10:
      case 11:
        return 'status-green';
      default:
        return 'status-green';
    }
  }
}
